import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import {
  LayoutDashboard, Map, MapPin, FileText, Star, Inbox, Home,
  Settings, Users, LogOut, ExternalLink, HelpCircle,
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/tours", label: "Tours", icon: Map },
  { to: "/admin/destinations", label: "Destinations", icon: MapPin },
  { to: "/admin/blog", label: "Blog", icon: FileText },
  { to: "/admin/testimonials", label: "Testimonials", icon: Star },
  { to: "/admin/faqs", label: "FAQs", icon: HelpCircle },
  { to: "/admin/enquiries", label: "Enquiries", icon: Inbox },
  { to: "/admin/homepage", label: "Homepage", icon: Home },
  { to: "/admin/settings", label: "Settings & SEO", icon: Settings },
  { to: "/admin/users", label: "Users", icon: Users, adminOnly: true },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  if (user === null) return <div className="min-h-screen grid place-items-center bg-[#fdfbf7] text-[#5a4b4b]">Loading…</div>;
  if (user === false) return <Navigate to="/admin/login" replace />;

  const doLogout = async () => { await logout(); nav("/admin/login"); };

  return (
    <div className="min-h-screen flex bg-[#faf8f5]">
      {/* Sidebar */}
      <aside className="w-64 shrink-0 bg-[#2d1616] text-white flex flex-col fixed inset-y-0 left-0 z-40">
        <div className="px-6 py-6 border-b border-white/10">
          <div className="font-serif text-xl">Legacy <span className="italic text-[#e8c970]">India Travel</span></div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#d4af37] mt-1">Admin CMS</div>
        </div>
        <nav className="flex-1 overflow-y-auto py-4">
          {NAV.filter((n) => !n.adminOnly || user.role === "admin").map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`nav-${n.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className={({ isActive }) => `flex items-center gap-3 px-6 py-3 text-sm transition-colors ${isActive ? "bg-[#7c1d1d] text-white border-r-2 border-[#d4af37]" : "text-white/70 hover:text-white hover:bg-white/5"}`}>
              <n.icon className="w-4 h-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-white/10 p-4 space-y-2">
          <a href="/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-xs text-white/60 hover:text-[#e8c970] px-2 py-2"><ExternalLink className="w-4 h-4" /> View Website</a>
          <div className="px-2 text-[11px] text-white/50">{user.name} · {user.role}</div>
          <button onClick={doLogout} data-testid="admin-logout" className="w-full flex items-center gap-2 text-sm text-white/80 hover:text-white bg-white/5 px-3 py-2.5"><LogOut className="w-4 h-4" /> Logout</button>
        </div>
      </aside>

      {/* Content */}
      <div className="flex-1 ml-64 min-w-0">
        <div className="p-6 sm:p-10 max-w-[1200px]">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
